import { Dropdown, Progress, Slider } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { formatToDuration } from "../../Utilis/helpers";
import "./style.scss";
import { CaretRightOutlined, PauseOutlined } from "@ant-design/icons";

var ogv = require("ogv");
ogv.OGVLoader.base = process.env.PUBLIC_URL + "/ogv";

type Props = {
  src: string;
};

const OgaPlayer = ({ src }: Props) => {
  const player = new ogv.OGVPlayer();
  const [currentTime, setCurrentTime] = useState(0);
  const [rate, setRate] = useState(1);
  const [duration, setDuration] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const playerRef = useRef<HTMLAudioElement>(player);
  const playerContainerRef = useRef<HTMLDivElement>(null);

  console.log(src);

  function playAudio() {
    playerRef.current.play();
    setIsPlaying(true);
  }
  function puaseAudio() {
    playerRef.current.pause();
    setIsPlaying(false);
  }
  function changeAudioRate(rate: number) {
    playerRef.current.playbackRate = rate;
    setRate(rate);
  }

  useEffect(() => {
    // Now treat it just like a video or audio element
    playerContainerRef.current!.appendChild(playerRef.current);
    playerRef.current.src = src;

    const handleTimeUpdate = () =>
      setCurrentTime(playerRef.current.currentTime);
    const handleEnded = () => {
      setCurrentTime(0);
      setIsPlaying(false);
    };

    playerRef.current.addEventListener("timeupdate", handleTimeUpdate);
    playerRef.current.addEventListener("ended", handleEnded);

    const interval = setInterval(() => {
      setDuration(playerRef.current.duration);
      if (playerRef.current.duration) clearInterval(interval);
    }, 0);

    return () => {
      clearInterval(interval);
      playerRef.current.removeEventListener("timeupdate", handleTimeUpdate);
      playerRef.current.removeEventListener("ended", handleEnded);
    };
  }, []);

  return (
    <div className="oga-player">
      <div ref={playerContainerRef}></div>
      <div className="play-button">
        {isPlaying ? (
          <PauseOutlined onClick={() => puaseAudio()} />
        ) : (
          <CaretRightOutlined onClick={() => playAudio()} />
        )}
      </div>
      <div className="duration">
        {formatToDuration(currentTime * 1000, false)}/
        {formatToDuration(duration * 1000, false)}
      </div>
      <Slider
        value={currentTime}
        max={duration}
        tooltip={{ formatter: null }}
        onChange={(value) => {
          setCurrentTime(value);
          playerRef.current.currentTime = value;
        }}
      />

      <Dropdown
        trigger={["click"]}
        overlayClassName="oga-rate-dropdown-menu"
        menu={{
          items: [0.5, 1, 1.5, 2].map((rate) => ({
            key: rate,
            label: (
              <div
                className="rate-option"
                onClick={() => changeAudioRate(rate)}
              >
                x{rate}
              </div>
            ),
          })),
        }}
      >
        <div>x{rate}</div>
      </Dropdown>
    </div>
  );
};

export default OgaPlayer;
